/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { CashBoxStatusesHistoryDto } from '../../../api/cashBoxes/cashBoxesClient.typings';
import {
    CashBoxStatusTabAction,
    CashBoxStatusTabActionType,
} from '../../../actions/CashBoxRegistry/Tabs/cashBoxStatusTabActions';

export interface CashBoxStatusTabState {
    cashBoxStatusesHistory: CashBoxStatusesHistoryDto;
    isLoadingStatusesHistory: boolean;
    isDownloadingStatusHistory: boolean;
}
const initialState: CashBoxStatusTabState = {
    cashBoxStatusesHistory: null,
    isLoadingStatusesHistory: false,
    isDownloadingStatusHistory: false,
};

export function cashBoxStatusTabReducer(
    state: CashBoxStatusTabState = initialState,
    action: CashBoxStatusTabAction,
): CashBoxStatusTabState {
    switch (action.type) {
        case CashBoxStatusTabActionType.FETCH_CASHBOX_STATUS_HISTORY:
            return {
                ...state,
                isLoadingStatusesHistory: true,
            };

        case CashBoxStatusTabActionType.FETCH_CASHBOX_STATUS_HISTORY_SUCCESS:
            return {
                ...state,
                isLoadingStatusesHistory: false,
                cashBoxStatusesHistory: action.payload,
            };

        case CashBoxStatusTabActionType.FETCH_CASHBOX_STATUS_HISTORY_ERROR:
            return {
                ...state,
                isLoadingStatusesHistory: false,
                cashBoxStatusesHistory: {
                    count: 0,
                    statuses: [],
                },
            };

        case CashBoxStatusTabActionType.DOWNLOAD_STATUS_HISTORY:
            return {
                ...state,
                isDownloadingStatusHistory: true,
            };

        case CashBoxStatusTabActionType.DOWNLOAD_STATUS_HISTORY_SUCCESS:
        case CashBoxStatusTabActionType.DOWNLOAD_STATUS_HISTORY_ERROR:
            return {
                ...state,
                isDownloadingStatusHistory: false,
            };

        case CashBoxStatusTabActionType.EXIT_CASHBOX_STATUS_TAB:
            return {
                ...state,
                cashBoxStatusesHistory: null,
            };

        default:
            break;
    }
    return state;
}
